import { render, staticRenderFns } from "./PemutakhiranForm.vue?vue&type=template&id=2a320548&"
import script from "./PemutakhiranForm.vue?vue&type=script&lang=js&"
export * from "./PemutakhiranForm.vue?vue&type=script&lang=js&"
import style0 from "./PemutakhiranForm.vue?vue&type=style&index=0&id=2a320548&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports